/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * RumbleDirect API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorJsonJsonproblem,
  ErrorJsonldJsonld,
  VehicleVehicleRegistrationResourceVehicleRegistrationOutputJsonld
} from '../model';

import { customInstance } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get vehicle registration status by license plate
 */
export const getLicensePlateCountryIdentifier = (
    country: string,
    identifier: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VehicleVehicleRegistrationResourceVehicleRegistrationOutputJsonld>(
      {url: `/license-plate/${country}/${identifier}`, method: 'GET', signal
    },
      options);
    }




export const getGetLicensePlateCountryIdentifierQueryKey = (country: string,
    identifier: string,) => {
    return [
    `/license-plate/${country}/${identifier}`
    ] as const;
    }


export const getGetLicensePlateCountryIdentifierQueryOptions = <TData = Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(country: string,
    identifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLicensePlateCountryIdentifierQueryKey(country,identifier);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>> = ({ signal }) => getLicensePlateCountryIdentifier(country,identifier, requestOptions, signal);





   return  { queryKey, queryFn, enabled: country !== null && country !== undefined && identifier !== null && identifier !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLicensePlateCountryIdentifierQueryResult = NonNullable<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>>
export type GetLicensePlateCountryIdentifierQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetLicensePlateCountryIdentifier<TData = Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 country: string,
    identifier: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicensePlateCountryIdentifier<TData = Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 country: string,
    identifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicensePlateCountryIdentifier<TData = Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 country: string,
    identifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get vehicle registration status by license plate
 */

export function useGetLicensePlateCountryIdentifier<TData = Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 country: string,
    identifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicensePlateCountryIdentifier>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLicensePlateCountryIdentifierQueryOptions(country,identifier,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






